import React, { useState, useRef, useEffect } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Sparkles, Send, Loader2 } from "lucide-react";

export default function AIAssistant() {
  const [messages, setMessages] = useState([
    { role: "assistant", content: "Buongiorno, sono l'assistente AI dello Studio Tozzi. Come posso aiutarla oggi? Posso riassumere pratiche, redigere bozze email, analizzare scadenze o rispondere a domande operative." }
  ]);
  const [input, setInput] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, busy]);

  const send = async () => {
    if (!input.trim() || busy) return;
    const msg = input;
    setMessages(m => [...m, { role: "user", content: msg }]);
    setInput("");
    setBusy(true);
    try {
      const { data } = await api.post("/ai/chat", { message: msg, session_id: sessionId });
      setSessionId(data.session_id);
      setMessages(m => [...m, { role: "assistant", content: data.reply }]);
    } catch (e) {
      setMessages(m => [...m, { role: "assistant", content: "Errore: impossibile contattare l'assistente AI." }]);
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-5 max-w-4xl mx-auto h-[calc(100vh-9rem)]">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-md bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center"><Sparkles className="w-5 h-5 text-white" /></div>
        <div>
          <h1 className="text-2xl font-heading font-bold text-navy-900">AI Assistant</h1>
          <p className="text-sm text-slate-500">Powered by Claude Sonnet 4.5 · solo per soci e admin</p>
        </div>
      </div>

      <Card className="flex-1 flex flex-col h-[calc(100%-4rem)] overflow-hidden">
        <div className="flex-1 overflow-y-auto p-6 space-y-4" data-testid="chat-messages">
          {messages.map((m, i) => (
            <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[80%] rounded-lg px-4 py-3 text-sm whitespace-pre-line ${m.role === "user" ? "bg-navy-800 text-white" : "bg-slate-100 text-slate-800"}`}>
                {m.content}
              </div>
            </div>
          ))}
          {busy && <div className="flex justify-start"><div className="bg-slate-100 rounded-lg px-4 py-3 text-sm text-slate-500 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Sto pensando...</div></div>}
          <div ref={endRef} />
        </div>
        <div className="border-t border-slate-200 p-4 flex gap-2">
          <Input value={input} onChange={(e)=>setInput(e.target.value)} onKeyDown={(e)=>e.key==="Enter"&&send()} placeholder="Chiedi qualsiasi cosa sullo studio..." disabled={busy} data-testid="chat-input" />
          <Button onClick={send} disabled={busy || !input.trim()} className="bg-navy-800 hover:bg-navy-900" data-testid="chat-send-btn"><Send className="w-4 h-4" /></Button>
        </div>
      </Card>
    </div>
  );
}
